function getDefaultWeight(font, platform) {
    if (font === 'styrene') {
        return 'medium';
    }
    if (platform === 'desktop') {
        return 'bold';
    }
    return 'semibold';
}

export { getDefaultWeight };
